"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CreateWorkByWizardLayout_1 = __importDefault(require("@Scenes/WorkScenes/CreateWorkByWizardLayout"));
const WorkDetailsStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/WorkDetailsStep"));
const WritersStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/WritersSteps/WritersStep"));
const WritersSharesRolesStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/WritersSteps/WritersSharesRolesStep"));
const PublishersStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/PublishersSteps/PublishersStep"));
const PublishersShareStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/PublishersSteps/PublishersShareStep"));
const PublishersRelationsStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/PublishersSteps/PublishersRelationsStep"));
const RecordingsStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/RecordingsStep"));
const ReviewWorkFormScene_1 = __importDefault(require("@Scenes/WorkScenes/ReviewWorkFormScene"));
const SubmissionStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/SubmissionStep"));
const react_1 = __importDefault(require("react"));
const navigation_1 = __importDefault(require("@App/navigation"));
const permissions_1 = require("@Const/permissions");
const PermissionCheck_1 = __importDefault(require("@Components/PermissionCheck"));
const route_1 = require("@App/navigation/route");
const createCreateWorkByWizardRoutes = () => ({
    path: route_1.WIZARD_ROUTE,
    element: (react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.view_works], orIsInternal: true, reRouteLocation: navigation_1.default.home.root() },
        react_1.default.createElement(CreateWorkByWizardLayout_1.default, null))),
    children: [
        {
            path: route_1.STEP_ROUTES.workDetails,
            element: react_1.default.createElement(WorkDetailsStep_1.default, null),
        },
        {
            path: route_1.STEP_ROUTES.writers,
            element: react_1.default.createElement(WritersStep_1.default, null),
        },
        {
            path: route_1.STEP_ROUTES.writersShares,
            element: react_1.default.createElement(WritersSharesRolesStep_1.default, null),
        },
        {
            path: route_1.STEP_ROUTES.publishers,
            element: react_1.default.createElement(PublishersStep_1.default, null),
        },
        {
            path: route_1.STEP_ROUTES.publishersShares,
            element: react_1.default.createElement(PublishersShareStep_1.default, null),
        },
        {
            path: route_1.STEP_ROUTES.publishersWriters,
            element: react_1.default.createElement(PublishersRelationsStep_1.default, null),
        },
        {
            path: route_1.STEP_ROUTES.recordings,
            element: react_1.default.createElement(RecordingsStep_1.default, null),
        },
        {
            path: route_1.STEP_ROUTES.review,
            element: react_1.default.createElement(ReviewWorkFormScene_1.default, { workType: 'create-wizard' }),
        },
        {
            path: route_1.STEP_ROUTES.submission,
            element: react_1.default.createElement(SubmissionStep_1.default, null),
        },
    ],
});
exports.default = createCreateWorkByWizardRoutes;
